import { render } from "./DialogNotSpecifyEBINA.vue?vue&type=template&id=f47b3fb4"
import script from "./DialogNotSpecifyEBINA.vue?vue&type=script&lang=js"
export * from "./DialogNotSpecifyEBINA.vue?vue&type=script&lang=js"
script.render = render

export default script